import { Button, Group, Modal, Stack, Text } from '@inflearn/ds-react-next';

interface GameExitConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const GameExitConfirmModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: GameExitConfirmModalProps) => {
  return (
    <Modal.Root opened={isOpen} onClose={onCancel} size="md" closeOnClickOutside={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>게임을 나가시겠습니까?</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <Stack gap="md" py="md">
            <Text size="md" c="gray.7">
              진행 중인 게임이 있습니다.
              <br />
              나가시면 게임 기록이 저장되지 않습니다.
            </Text>
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Group justify="flex-end" gap="sm">
            <Button variant="subtle" onClick={onCancel}>
              취소
            </Button>
            <Button color="red" onClick={onConfirm}>
              나가기
            </Button>
          </Group>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
